import { TemplateIcon } from "../../../assets/svg/TemplateIcon";
import styles from "./TemplateButton.module.scss";
import { CloseIcon } from "../../../assets/svg/CloseIcon";
import { RenderIcon } from "../../../assets/svg/RenderIcon";
import { TemplateList } from "../TemplateList/TemplateList";
import { LeftDrawer } from "../../../shared/LeftDrawer/LeftDrawer";
import { EViewType, useURLRouting } from "../../../utils/hooks/useURLRouting";
import { useAppDispatch } from "../../../redux/store";
import { changeShowModal } from "../../../redux/reducers/app/appReducer";

export const TemplateButton = () => {
  const dispatch = useAppDispatch();
  const { currentView, setTemplate, resetTemplate } = useURLRouting();

  const handleToggleDrawer = (): void => {
    if (currentView && currentView.type === EViewType.Templates) {
      resetTemplate();
    } else {
      setTemplate("");
    }
  };

  // Determine if we're inside a template view (a specific folder opened)
  const isTemplateItemView =
    currentView &&
    currentView.type === EViewType.Templates &&
    currentView.template_id !== undefined;

  const handleSaveClick = () => {
    // Always open the universal CreateFolderModal (which now handles both templates and folders)
    dispatch(
      changeShowModal({
        nameModal: "createFolderModal",
        stateModal: true,
      })
    );
  };

  return (
    <div className={styles.wrapper} data-tour="templates-btn">
      <button
        type="button"
        onClick={handleToggleDrawer}
        className={currentView.type === EViewType.Templates ? "active" : ""}
      >
        <TemplateIcon />
      </button>
      {currentView && currentView.type === EViewType.Templates ? (
        <LeftDrawer>
          <div className={styles.layer_wrapper}>
            <div className={styles.header} id="templates-header">
              <p>Templates</p>
              <button type="button" onClick={() => resetTemplate()}>
                <CloseIcon />
              </button>
            </div>
            <TemplateList />
            <div className={styles.footer} id="templates-footer">
              <div className={styles.information}>
                <button type="button" onClick={handleSaveClick}>
                  <RenderIcon /> Save Template
                </button>
              </div>
            </div>
          </div>
        </LeftDrawer>
      ) : null}
    </div>
  );
};
